<template>
    <div class="contactUs-content">
        <menuBox :step="4"></menuBox>
        <div class="motto-box">
            <p class="bt">ติดต่อเรา</p>
        </div>
        <div class="contactUs">
            <div class="contactUs-box">
                <div class="contactUs-infos">
                    <div class="title">เกี่ยวกับบริการของเรา</div>
                    <div class="text">เรายังคงให้บริการที่มีมูลค่าสูงแก่คุณผ่านการปรับปรุงอย่างมืออาชีพอย่างต่อเนื่อง
                    </div>
                    <div class="itemBox">
                        <div class="item">
                            <img src="../assets/Background.png" alt="">
                            <div class="contentInfo">
                                <p>1. อนุมัติเร็ว</p>
                                <span>หลังจากส่งใบสมัครแล้ว จะมีการตรวจสอบอย่างรวดเร็วและจะปล่อยเงินกู้ทันทีในวันเดียวกันเพื่อแก้ไขความต้องการทางการเงินของคุณ</span>
                            </div>
                        </div>
                        <div class="item">
                            <img src="../assets/Background2.png" alt="">
                            <div class="contentInfo">
                                <p>2. ยืดหยุ่นและสะดวกสบาย</p>
                                <span>จำนวนเงินกู้และระยะเวลาการชำระคืนมีความยืดหยุ่นเพื่อตอบสนองความต้องการส่วนบุคคลของผู้ใช้ที่แตกต่างกัน</span>
                            </div>
                        </div>
                        <div class="item">
                            <img src="../assets/Background3.png" alt="">
                            <div class="contentInfo">
                                <p>3. ปลอดภัยและเชื่อถือได้</p>
                                <span>ปฏิบัติตามมาตรฐานการปฏิบัติตามข้อกำหนดทางการเงินอย่างเคร่งครัดและใช้เทคโนโลยีการเข้ารหัสขั้นสูงเพื่อให้มั่นใจในความปลอดภัยของข้อมูลและธุรกรรมของคุณ</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="about-content">
                <div class="bt">ติดต่อทีมงานของเรา</div>
                <div class="title">หากท่านสนใจร่วมมือหรือต้องการความช่วยเหลือด้านบริการ กรุณาติดต่อเรา</div>
                <div class="sub-box">
                    <img src="../assets/group.png" alt="">
                    <div class="lineBox">
                        <div class="line">
                            <input type="text" placeholder="นามสกุล" />
                            <input type="text" placeholder="ชื่อ" />
                        </div>
                        <div class="line">
                            <input type="text" placeholder="จดหมาย" />
                            <input type="text" placeholder="โทรศัพท์มือถือ" />
                        </div>
                        <textarea class="message" type="text" placeholder="ข้อความ" />
                        <div class="checkBox">
                            <input type="checkBox" />
                            <p>ฉันยอมรับว่าเบรนทรีสามารถติดต่อฉันได้ตามที่อยู่อีเมลหรือหมายเลขโทรศัพท์ด้านบน</p>
                        </div>
                        <div class="btn" @click="submit()">สง</div>
                    </div>

                </div>
            </div>
        </div>

        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: "App",
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {};
    },
    mounted() {
        this.scrollToElement()
    },
    methods: {
        scrollToElement() {
            this.$nextTick(() => {
                let hashs = location.hash.slice(1).split('&');
                console.log(hashs);
                document.getElementById(hashs).scrollIntoView();
            });
        },
        submit() {
            alert('ความสำเร็จ!')
        }
    },
};
</script>
<style lang="less" scoped>
.contactUs-content {
    .motto-box {
        background-image: url(../assets/contacts.png);
        width: 100%;
        height: 500px;
        background-size: 100% 100%;
        padding: 180px 0 0 0;
        position: relative;
        box-sizing: border-box;

        .bt {
            text-align: center;
            margin-bottom: 35px;
            font-size: 58px;
            font-family: Roboto, Roboto;
            font-weight: 800;
            color: #FFFFFF;
        }
    }

    .contactUs {
        background-color: #F5F7FB;

        .appLogo {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 60px 310px;
            box-sizing: border-box;

            div {
                p {
                    margin-bottom: 20px;
                    font-size: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 600;
                    color: #37393F;
                }

                span {
                    font-size: 30px;
                    font-family: PingFang SC, PingFang SC;
                    color: #666;
                }
            }

            img {
                margin-left: 100px;
                width: 300px;
            }
        }

        .contactUs-box {
            padding: 100px 310px 100px;
            box-sizing: border-box;

            .title {
                max-width: 600px;
                text-align: center;
                margin: 17px auto 11px;
                font-size: 40px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                color: #37393F;
            }

            .text {
                max-width: 600px;
                text-align: center;
                margin: 0 auto 60px;
                font-size: 18px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                color: #7D7D7D;
            }

            .itemBox {
                display: flex;
                align-items: center;
            }

            .item {
                margin-right: 40px;
                position: relative;

                img {

                    width: 405px;
                    height: 329px;
                }

                .contentInfo {
                    width: 340px;
                    position: absolute;
                    left: 40px;
                    top: 140px;

                    p {
                        margin-bottom: 6px;
                        font-size: 16px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        color: #7D7D7D;
                    }

                    span {
                        font-size: 18px;
                        font-family: Poppins, Poppins;
                        font-weight: 600;
                        color: #37393F;
                    }
                }

            }
        }
    }

    .about-content {
        padding: 0 310px 160px;

        .bt {
            text-align: center;
            margin-bottom: 24px;
            font-size: 54px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #1A191E;
        }

        .title {
            text-align: center;
            margin-bottom: 100px;
            font-size: 18px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #333215;
        }

        .sub-box {
            display: flex;
            align-items: center;
            justify-content: space-between;

            img {
                margin-right: 40px;
                width: 585px;
                height: 417px;
            }

            .lineBox {
                flex: 1;
            }

            .line {
                display: flex;
            }

            input,
            textarea {
                margin-right: 35px;
                background: #fff;
                width: 100%;
                padding: 0 20px;
                border-radius: 8px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                height: 60px;
                border: 1px solid #00387A;
                margin-bottom: 28px;
                box-sizing: border-box;
            }

            input:nth-child(2) {
                margin-right: 0;
            }

            .message {
                width: 100%;
                height: 120px;
                padding: 20px;
                box-sizing: border-box;
            }

            .btn {
                margin: 28px auto 0;
                background: #F26621;
                line-height: 67px;
                font-size: 20px;
                font-family: Arial, Arial;
                color: #FFFFFF;
                text-align: center;
                cursor: pointer;
                border-radius: 37px 37px 37px 37px;
            }

            .checkBox {
                display: flex;

                input {
                    width: 25px;
                    height: 25px;
                    background: #00387A;
                }

                p {
                    font-size: 18px;
                    font-family: Roboto, Roboto;
                    font-weight: 400;
                    color: #00387A;
                    line-height: 22px;
                }
            }
        }
    }
}
</style>